import { useModal } from '@ebay/nice-modal-react'
import copy from 'copy-to-clipboard'
import { useState } from 'react'

import ToastMessage from '../components/common/toast-message'

const useCopy = () => {
  const toastMessageModal = useModal(ToastMessage)
  const [isCopied, setIsCopied] = useState(false)

  function copyTextToClipboard(text: string, toastMessage?: string) {
    copy(text)
    if (toastMessage) {
      toastMessageModal.show({
        text: toastMessage,
        isValid: true,
      })
    }
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 3000)
  }

  return { copyTextToClipboard, isCopied }
}

export default useCopy
